import React, { useEffect, useState } from "react";
import { useSearcher } from "../../../shared/search/components/SearcherContext";
import { Dropdown, Form } from "semantic-ui-react";
import { ObjectProperty } from "../../../shared/object/components/ObjectPropertyList";

function speciesDisplayName(obj) {
  return obj.SCIENTIFICNAME && obj.SCIENTIFICNAME[0];
}

function stripGbifPrefix(kosmeoId) {
  return kosmeoId.replace("gbif_", "");
}

const SpeciesSelector = ({ search, section, onChange }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    search.searchObjectTypes("", "species", { section }).then(({ hits }) =>
      setOptions(
        hits.map(obj => ({
          key: obj.ID[0],
          value: obj.ID[0],
          text: speciesDisplayName(obj)
        }))
      )
    );
  }, [search, section]);

  return (
    <Dropdown
      placeholder="Select a species"
      search
      fluid
      selection
      clearable
      onChange={(e, { value }) => onChange(value)}
      options={options}
    />
  );
};

export const SpeciesFacetFilter = ({ section, header }) => {
  const search = useSearcher();
  const onSpeciesChange = id => {
    search.addFilter([
      {
        filterId: null,
        filterType: "A",
        fieldName: "SPECIES",
        fieldValue: id
      }
    ]);
  };
  return (
    <Form.Field className="filter-field">
      {header}
      <SpeciesSelector
        search={search}
        section={section}
        onChange={onSpeciesChange}
      />
    </Form.Field>
  );
};

export const SpeciesLink = ({ obj, prop }) => {
  const species =
    obj.hasOwnProperty(prop.key) && obj[prop.key].length > 0
      ? obj[prop.key][0]
      : null;

  if (species === null) {
    return null;
  }

  // only species id is available
  if (typeof species === "string") {
    return (
      <ObjectProperty label={prop.label || prop.key}>
        <a
          rel="noopener noreferrer"
          target="_blank"
          href={"https://www.gbif.org/search?q=" + encodeURI(species)}
        >
          {species}
        </a>
      </ObjectProperty>
    );
  }

  // person prop is object literal
  const gbifId = stripGbifPrefix(species["ID"][0]);
  return (
    <ObjectProperty label={prop.label || prop.key}>
      <a
        rel="noopener noreferrer"
        target="_blank"
        href={"https://www.gbif.org/species/" + gbifId}
      >
        {speciesDisplayName(species)}
      </a>
    </ObjectProperty>
  );
};

export default { Filter: SpeciesFacetFilter, Link: SpeciesLink };
